// Wave RW.2 (2026-05-17) — ERP 웹 PROMISE 출품 목록
// API: GET /api/rfq/inquiries → { success, data: [...inquiry] }
// 단일 fetch + client-side 탭 필터 (출시 시 LIMIT 200 충분, 백로그: pagination)

import React, { useState, useEffect, useCallback } from 'react';
import { API, authFetch } from '../../utils/api';

var TABS = [
  { key: 'open',      label: '진행중',  statuses: ['open'] },
  { key: 'committed', label: '매입중',  statuses: ['committed'] },
  { key: 'completed', label: '완료',    statuses: ['completed'] },
  { key: 'closed',    label: '종료',    statuses: ['failed', 'cancelled', 'expired'] },
];

// RN 정합 — status별 색상 (라벨은 탭 라벨과 분리)
var STATUS_LABEL = {
  open:      '입찰 모이는 중',
  committed: '매입 결정 (3일)',
  completed: '거래 완료',
  failed:    '매입 실패',
  cancelled: '취소',
  expired:   '만료',
};
var STATUS_COLOR = {
  open:      '#2563eb',
  committed: '#f59e0b',
  completed: '#10b981',
  failed:    '#ef4444',
  cancelled: '#94a3b8',
  expired:   '#94a3b8',
};

function formatKrw(n) {
  if (n == null) return '-';
  return (n / 10000).toFixed(0) + '만원';
}
function formatMileage(km) {
  if (km == null || km === 0) return '';
  return Number(km).toLocaleString() + ' km';
}
function formatRemaining(expiresAt) {
  if (!expiresAt) return '';
  var end = new Date(expiresAt).getTime();
  var diff = end - Date.now();
  if (diff <= 0) return '만료';
  var d = Math.floor(diff / 86400000);
  var h = Math.floor((diff % 86400000) / 3600000);
  var m = Math.floor((diff % 3600000) / 60000);
  if (d > 0) return 'D-' + d;
  if (h > 0) return h + '시간 ' + m + '분';
  return m + '분';
}
function thumbUrl(inquiry) {
  var photos = inquiry && inquiry.photos;
  if (!photos) return null;
  // parsePhotos 가 array 보장 (object 도 Object.values 로 변환됨)
  var first = Array.isArray(photos) ? photos[0] : null;
  if (!first) return null;
  // element 는 string (path) 또는 object — 둘 다 대응
  if (typeof first === 'string') return first.charAt(0) === '/' ? first : '/' + first;
  if (first.url)  return first.url;
  if (first.path) return first.path.charAt(0) === '/' ? first.path : '/' + first.path;
  return null;
}

function RFQList(props) {
  var onNew = props.onNew || function(){};
  var onSelect = props.onSelect || null;  // Wave RW.3 (2026-05-17) — 카드 클릭 → 상세
  var [tab, setTab] = useState('open');
  var [items, setItems] = useState([]);
  var [loading, setLoading] = useState(true);
  var [error, setError] = useState('');

  var load = useCallback(function() {
    setLoading(true);
    setError('');
    authBuyerFetchSafe(API + '/rfq/inquiries')
      .then(function(r){ return r.json(); })
      .then(function(d) {
        if (d && d.success && Array.isArray(d.data)) {
          setItems(d.data);
        } else {
          setError((d && d.error) || '목록 로드 실패');
        }
        setLoading(false);
      })
      .catch(function(){ setError('네트워크 오류'); setLoading(false); });
  }, []);

  useEffect(function(){ load(); }, [load]);

  // client-side 필터 — 단일 fetch 후 탭 분류
  var currentTab = TABS.find(function(t){ return t.key === tab; }) || TABS[0];
  var filtered = items.filter(function(a) {
    return currentTab.statuses.indexOf(a.status) >= 0;
  });

  var counts = {};
  TABS.forEach(function(t) {
    counts[t.key] = items.filter(function(a){ return t.statuses.indexOf(a.status) >= 0; }).length;
  });

  return (
    <div style={{ padding: '20px 24px', maxWidth: 1280, margin: '0 auto' }}>
      {/* 헤더 */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
        <h2 style={{ fontSize: 22, fontWeight: 800, color: '#0f172a' }}>
          🤝 PROMISE 출품
        </h2>
        <button type="button" onClick={onNew} style={newBtn}>
          + 새 출품
        </button>
      </div>

      {/* 탭 */}
      <div style={{ display: 'flex', gap: 4, borderBottom: '1.5px solid #e2e8f0', marginBottom: 20 }}>
        {TABS.map(function(t) {
          var active = tab === t.key;
          return (
            <button key={t.key} type="button" onClick={function(){ setTab(t.key); }}
              style={{
                padding: '12px 18px',
                background: 'transparent', border: 'none',
                borderBottom: active ? '2.5px solid #1B3A5C' : '2.5px solid transparent',
                fontSize: 14, fontWeight: active ? 700 : 600,
                color: active ? '#1B3A5C' : '#64748b',
                cursor: 'pointer',
                fontFamily: "'Pretendard',sans-serif",
                marginBottom: '-1.5px',
                display: 'flex', alignItems: 'center', gap: 6,
              }}>
              <span>{t.label}</span>
              <span style={{
                fontSize: 11, fontWeight: 700,
                background: active ? '#1B3A5C' : '#e2e8f0',
                color: active ? 'white' : '#64748b',
                padding: '2px 8px', borderRadius: 10,
                minWidth: 18, textAlign: 'center',
              }}>{counts[t.key] || 0}</span>
            </button>
          );
        })}
      </div>

      {/* 본문 */}
      {loading && (
        <div style={emptyBox}>불러오는 중...</div>
      )}

      {!loading && error && (
        <div style={{ padding: '60px 0', textAlign: 'center' }}>
          <div style={{ color: '#dc2626', fontSize: 14, marginBottom: 12 }}>{error}</div>
          <button type="button" onClick={load} style={retryBtn}>다시 시도</button>
        </div>
      )}

      {!loading && !error && filtered.length === 0 && (
        <div style={emptyBox}>
          <div style={{ fontSize: 14, marginBottom: 16 }}>
            {tab === 'open' ? '진행중인 출품이 없습니다' :
             tab === 'committed' ? '매입중인 출품이 없습니다' :
             tab === 'completed' ? '완료된 거래가 없습니다' :
             '종료된 출품이 없습니다'}
          </div>
          {tab === 'open' && (
            <button type="button" onClick={onNew} style={newBtn}>+ 새 출품 만들기</button>
          )}
        </div>
      )}

      {!loading && !error && filtered.length > 0 && (
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))',
          gap: 16,
        }}>
          {filtered.map(function(a) { return <RFQCard key={a.id} inquiry={a} onSelect={onSelect} />; })}
        </div>
      )}
    </div>
  );
}

function RFQCard(props) {
  var a = props.inquiry;
  var onSelect = props.onSelect;
  var thumb = thumbUrl(a);
  var statusColor = STATUS_COLOR[a.status] || '#94a3b8';
  var statusText  = STATUS_LABEL[a.status] || a.status;
  var remaining = a.status === 'open' ? formatRemaining(a.expiresAt) : '';
  var clickable = !!onSelect;

  // Wave RW.3 — 카드 클릭 시 상세 페이지로. onSelect 콜백 있을 때만 활성.
  var cellStyle = clickable
    ? Object.assign({}, cardBase, { cursor: 'pointer', transition: 'box-shadow 0.15s, transform 0.15s' })
    : cardBase;

  return (
    <div
      onClick={clickable ? function(){ onSelect(a.id); } : null}
      onMouseEnter={clickable ? function(e){ e.currentTarget.style.boxShadow='0 8px 20px rgba(15,23,42,0.08)'; e.currentTarget.style.transform='translateY(-2px)'; } : null}
      onMouseLeave={clickable ? function(e){ e.currentTarget.style.boxShadow='none'; e.currentTarget.style.transform='none'; } : null}
      style={cellStyle}>
      <div style={{ position: 'relative', width: '100%', aspectRatio: '4/3', background: '#f1f5f9' }}>
        {thumb ? (
          <img src={thumb} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
            onError={function(e){ try { e.target.style.display='none'; } catch(_e){} }} />
        ) : (
          <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#94a3b8', fontSize: 13 }}>
            사진 없음
          </div>
        )}
        {a.ownerConsented && (
          <div style={{
            position: 'absolute', top: 8, left: 8,
            background: '#10b981', color: 'white',
            padding: '3px 8px', borderRadius: 5,
            fontSize: 10, fontWeight: 700,
          }}>차주 동의 ✓</div>
        )}
        {remaining && (
          <div style={{
            position: 'absolute', bottom: 8, left: 8,
            background: 'rgba(15,23,42,0.75)', color: 'white',
            padding: '3px 8px', borderRadius: 5,
            fontSize: 11, fontWeight: 700,
          }}>{remaining}</div>
        )}
      </div>

      <div style={{ padding: 12, display: 'flex', flexDirection: 'column', gap: 4 }}>
        <div style={{ fontSize: 14, fontWeight: 800, color: '#0f172a', lineHeight: 1.3, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
          {a.year ? a.year + ' ' : ''}{a.model || '차량'}
        </div>
        <div style={{ fontSize: 12, color: '#94a3b8' }}>
          {a.carNo || '-'}
          {formatMileage(a.mileage) && (<span> · {formatMileage(a.mileage)}</span>)}
        </div>
        <div style={{ marginTop: 6, paddingTop: 8, borderTop: '1px solid #f1f5f9', display: 'flex', justifyContent: 'space-between', alignItems: 'baseline' }}>
          <div style={{ fontSize: 11, color: '#94a3b8' }}>
            시세 {a.quoteCount || 0}건
          </div>
          <div style={{ fontSize: 13, fontWeight: 800, color: '#1B3A5C' }}>
            {a.maxPriceKrw > 0 ? formatKrw(a.maxPriceKrw) : <span style={{ color: '#94a3b8', fontSize: 11, fontWeight: 600 }}>대기</span>}
          </div>
        </div>
        <div style={{ marginTop: 6, display: 'flex' }}>
          <span style={{
            background: statusColor, color: 'white',
            padding: '3px 8px', borderRadius: 5,
            fontSize: 10, fontWeight: 700,
          }}>{statusText}</span>
        </div>
      </div>
    </div>
  );
}

// helper — utils/api.js authFetch 가 export 표준명. 안전 wrapper (네트워크 reject 시 .json() 호출 막힘 방지).
function authBuyerFetchSafe(url) {
  return authFetch(url, {});
}

// styles
var newBtn = {
  padding: '8px 16px',
  background: '#1B3A5C', color: 'white',
  border: 'none', borderRadius: 8,
  fontSize: 13, fontWeight: 700,
  cursor: 'pointer',
  fontFamily: "'Pretendard',sans-serif",
};
var retryBtn = {
  padding: '8px 16px',
  background: 'white', border: '1.5px solid #e2e8f0', borderRadius: 8,
  fontSize: 13, fontWeight: 600, color: '#475569',
  cursor: 'pointer',
  fontFamily: "'Pretendard',sans-serif",
};
var emptyBox = {
  padding: '80px 20px', textAlign: 'center',
  color: '#94a3b8', fontSize: 14,
};
// RW.3 미구현 — cursor default + hover 효과 없음 (advisor 권고)
var cardBase = {
  background: 'white', borderRadius: 12,
  border: '1px solid #e2e8f0',
  overflow: 'hidden',
  display: 'flex', flexDirection: 'column',
};

export default RFQList;
